import i18n from '../../locales/index'
/* eslint-disable */
import { genBasicStore } from '../vuex';
import assign from 'lodash/assign';
import axios from 'axios';
import { Message } from 'view-design'

const store = genBasicStore('deduct_coupon');

assign(store.actions, {
  // async update ({ commit }, params) {
  //   const { ...others } = params;
  //   params.discount = +params.discount;
  //   params.upgrade_standard = +params.upgrade_standard;
  //   const response = await axios.put(`desks/${params.id}`, others)
  //   commit('updateRecordInRecords', response.data)
  //   Message.success('更新成功')
  // },
  // async create ({ commit }, options) {
  //   const { ...params } = options;
  //   params.discount = +params.discount;
  //   params.upgrade_standard = +params.upgrade_standard;
  //   const response = await axios.post('desks', params)
  //   commit('setRecord', response.data);
  //   commit('addRecordInRecords', response.data)
  //   Message.success('操作成功')
  // },
})

export default store;